import { SideNavConfig } from "@cws-ui/ngx-cws-app-layout";

export const LEFT_MENU_ITEMS:SideNavConfig={
  leftMenuItems: [
    {
      "title": {
        en: 'List of Contracts',
        ja: "ご契約一覧"
      },
      "visible": false,
      "href": "http://www.google.com",
      "name": "listOfContractsItem",
      "subItems": []
    },
    {
      "title": {
        en: 'Benefit Procedure',
        ja: "給付金手続き"
      },
      "href": "",
      "visible": true,
      "name": "benefitProcedureItem",
      "subItems": []
    },
    {
      "title": {
        en: 'Change Contract Information',
        ja: "ご契約情報の変更"
      },
      "visible": true,
      "name": "changeContractInformationItem",
      "subItems": [
        {
          "title": {
            en: 'Change Name policyholder insured InvoiceOrder',
            ja: "契約者・被保険者の改姓・改名［請求書取り寄せ"
          },
          "href": "",
          "visible": true,
          "name": "changeNamePolicyholderInsuredInvoiceOrderSubItem",
          "subItems": [],
          "metadata" : {
            "callCenterUser" : false
          }
        },
        {
          "title": {
            en: 'Change Name Beneficiary Designated Proxy Claimant Contractor InvoiceOrder',
            ja: "名義変更（受取人・指定代理請求人、契約者の変更）［請求書取り寄せ］"
          },
          "href": "",
          "visible": true,
          "name": "changeNameBeneficiaryDesignatedProxyClaimantContractorInvoiceOrderSubItem",
          "subItems": []
        },
        {
          "title": {
            en: "Change Address Phone Number",
            ja: "住所・電話番号変更"
          },
          "href": "",
          "visible": true,
          "name": "changeAddressPhoneNumberSubItem",
          "subItems": []
        },
      ]
    },
    {
      "title": {
        en: 'Accumulated Fund Transfer Switching',
        ja: "積立金移転（スイッチング）"
      },
      "visible": true,
      "href": "",
      "name": "accumulatedFundTransferSwitchingItem",
      "subItems": []
    },
    {
      "title": {
        en: 'Cancellation',
        ja: "解約"
      },
      "visible": true,
      "name": "cancellationItem",
      "subItems": [
        {
          "title": {
            en: 'Cancellation',
            ja: "解約"
          },
          "href": "",
          "visible": true,
          "name": "cancellationDynamicSubItem",
          "subItems": []
        }
      ]
    }, {
      "title": {
        en: 'Reissuance Procedure',
        ja: "再発行手続き"
      },
      "visible": true,
      "name": "reissueProcedureItem",
      "subItems": [
        {
          "title": {
            en: 'Issuance of a certificate of deduction for life insurance premiums',
            ja: "生命保険料控除証明書の発行"
          },
          "href": "",
          "visible": true,
          "name": "Issuance_LifeInsurance_Premium_Deduction_C",
          "subItems": []
        },
        {
          "title": {
            en: "Reissuance of insurance policy",
            ja: "保険証券再発行"
          },
          "href": "",
          "visible": true,
          "name": "Insurance_Policy_Reissue",
          "subItems": []
        }
      ]
    },
    {
      "title": {
        en: 'Contract Documents',
        ja: "契約書類"
      },
      "visible": true,
      "href": "",
      "name": "contractDocumentsItem",
      "subItems": []
    },
    {
      "title": {
        en: "Frequently Asked Questions",
        ja: "よくあるご質問"
      },
      "visible": true,
      "href": "",
      "name": "faqItem",
      "subItems":[]

    }
    ,
    {
      "title": {
        en: 'Contact Us',
        ja: "お問い合わせ"
      },
      "visible": true,
      "href": "",
      "name": "inquiryItem",
      "subItems":[]

    }
  ]
 
  }
  export const CWS_ANGULAR = "cws-angular";


